module.exports = __webpack_public_path__ + "media/confirm_style_1_echo_006.38a89e4f.mp3";